import { request } from 'cn-request';
/**
 * 请求类型
 */
var REQUEST_TYPE;
(function (REQUEST_TYPE) {
    /**
     * 搜索（阿里数据源）
     */
    REQUEST_TYPE["ALI_SEARCH"] = "ALI_SEARCH";
    /**
     * 按关键词搜索（菜鸟数据源）
     */
    REQUEST_TYPE["CAINIAO_SEARCH_BY_KEYWORD"] = "CAINIAO_SEARCH_BY_KEYWORD";
    /**
     * 按工号搜索（菜鸟数据源）
     */
    REQUEST_TYPE["CAINIAO_SEARCH_BY_STAFFID"] = "CAINIAO_SEARCH_BY_STAFFID";
})(REQUEST_TYPE || (REQUEST_TYPE = {}));
/**
 * 内置接口名称
 */
const INTERNAL_PATH_MAP = {
    [REQUEST_TYPE.ALI_SEARCH]: '/cmdp/hysmab/getAliUserInfoBySearchKey',
    [REQUEST_TYPE.CAINIAO_SEARCH_BY_KEYWORD]: '/cmdp/hysmab/fuzzyQueryOnJobEmployee',
    [REQUEST_TYPE.CAINIAO_SEARCH_BY_STAFFID]: '/cmdp/hysmab/getOnJobEmployeeByEmpNo',
};
/**
 * 非mokelay直接接入时的代理地址
 */
const NON_MOKELY_PROXY_PATH = '/cn-common-proxy/post';
/**
 * 拼接请求参数
 */
function buildRequestParams(params) {
    const { data, serviceType, fromType, mokelay = false, host = '', path = '', } = params;
    let requestType = REQUEST_TYPE.ALI_SEARCH;
    if (serviceType === 'ali') {
        requestType = REQUEST_TYPE.ALI_SEARCH;
    }
    else if (serviceType === 'cainiao') {
        requestType =
            fromType === 'keywords'
                ? REQUEST_TYPE.CAINIAO_SEARCH_BY_KEYWORD
                : REQUEST_TYPE.CAINIAO_SEARCH_BY_STAFFID;
    }
    else {
        throw new Error('invalid service type');
    }
    // 拼接地址，优先外部传入的path，其次host+mokelay判断
    const innerPath = INTERNAL_PATH_MAP[requestType];
    const builtPath = path || (mokelay ? innerPath : NON_MOKELY_PROXY_PATH);
    // 拼接参数
    const builtData = path || mokelay
        ? data
        : {
            path: innerPath,
            params: data,
        };
    // 最终请求参数
    const builtParams = {
        url: `${host}${builtPath}`,
        method: 'post',
        withCredentials: true,
        data: builtData,
    };
    if (mokelay) {
        builtParams.crossOrigin = true;
        builtParams.isCommonRequest = true;
    }
    return builtParams;
}
/**
 * 数据源格式化
 * @param items 原始数据源
 * @returns 符合组件结构的数据源
 */
export function processDataSource(items) {
    if (!Array.isArray(items))
        return [];
    return (items
        // item判空：针对数据源中包含null等值的情况；item.enabled判空：对应员工接口规范中的字段
        .filter((item) => item && item.enabled !== false)
        .map((item) => ({
        ...item,
        // 集团接口返回的是personalPhotoUrl，菜鸟接口用工号拼接头像
        personalPhotoUrl: item.personalPhotoUrl ||
            `https://work.alibaba-inc.com/photo/${item.workNo}.50x50.jpg`,
        // 集团接口返回的是deptName，菜鸟接口返回的是department
        department: item.department || item.deptName,
        label: item.nickName || item.name,
        value: item.workNo,
    })));
}
/**
 * 格式化返回数据
 * @param res 原始返回数据
 * @returns 格式化后可被下拉组件使用的数据
 */
export function formatResponse(res) {
    const resultData = (Array.isArray(res.data?.data) ? res.data?.data : res?.data) || res;
    if (!Array.isArray(resultData))
        return [];
    return processDataSource(resultData);
}
/**
 * 搜索
 */
export async function search(params) {
    const { mokelay, host, serviceType, fromType, path, value = '', typeList = [], isOnJob, } = params;
    const data = fromType === 'staffId' && value
        ? {
            empId: value,
        }
        : {
            searchKey: value,
        };
    if (serviceType === 'cainiao') {
        data.typeList = typeList.join(',');
        data.isOnJob = isOnJob;
    }
    const requestParams = buildRequestParams({
        data,
        mokelay,
        host,
        path,
        serviceType,
        fromType,
    });
    const result = await request(requestParams);
    const fomattedResult = formatResponse(result);
    return fomattedResult;
}
